import { defineComponent as B, ref as v, onMounted as I, watch as L, computed as b, openBlock as c, createElementBlock as u, normalizeStyle as N, normalizeClass as T, createElementVNode as f, toDisplayString as y, createBlock as A, createCommentVNode as U, Fragment as D, renderList as V, createVNode as $ } from "vue";
import { isImageFileWithExif as h, stripExifFromFile as x } from "@template/utils";
import { isNativeWebView as q } from "./index244.js";
import F from "./index60.js";
const W = ["disabled"], O = ["disabled", "multiple", "accept"], R = { class: "flex w-full flex-row items-center justify-center gap-1 px-6 py-3.5" }, M = { class: "text-sm font-normal" }, P = { key: 1 }, X = { class: "text-blue truncate text-sm underline underline-offset-1" }, Y = ["onClick"], K = /* @__PURE__ */ B({
  __name: "BaseFileUploadButton",
  props: {
    label: { default: "파일선택" },
    status: { default: "default" },
    disabled: { type: Boolean, default: !1 },
    showIcon: { type: Boolean, default: !0 },
    multiple: { type: Boolean, default: !1 },
    accept: { default: ".png,.jpg,.jpeg,.pdf" },
    maxFileSize: { default: 10 * 1024 * 1024 },
    initialFiles: { default: () => [] }
  },
  emits: ["click", "change", "remove", "file-selected", "file-size-error", "file-type-error"],
  setup(d, { emit: w }) {
    const e = d, o = w, g = v(null), n = v([]);
    I(() => {
      e.initialFiles && e.initialFiles.length > 0 && (n.value = [...e.initialFiles]);
    }), L(
      () => e.initialFiles,
      (t) => {
        t && t.length > 0 && (n.value = [...t]);
      }
    );
    const _ = b(() => {
      const t = [
        "relative w-full flex items-center rounded-sm border transition-colors duration-150",
        "bg-[#f3f4f6]",
        // 기본 배경색
        "border-bg-bg-outline",
        // 기본 테두리 색상
        "text-input-text-static"
        // 기본 텍스트 색상
      ];
      return e.disabled ? t.push("cursor-not-allowed opacity-60") : t.push("hover:bg-bg-surface"), t.join(" ");
    }), k = b(() => e.disabled ? {
      backgroundColor: "var(--button-disabled-background)",
      borderColor: "var(--button-disabled-border)",
      color: "var(--button-disabled-text)"
    } : e.status === "hover" ? {
      backgroundColor: "var(--base-colors-common-bg-surface-default)"
    } : {}), z = b(() => n.value.length > 0);
    async function C() {
      const s = (typeof window < "u" ? window.bridgeService : void 0)?.requestFileUpload;
      if (!s) return;
      const l = await s({ multiple: e.multiple });
      if (l.success && l.files?.length) {
        const r = [], a = ["png", "jpg", "jpeg", "pdf"];
        for (const i of l.files) {
          const p = i.name.split(".").pop()?.toLowerCase() || "";
          if (!a.includes(p)) {
            o("file-type-error", i, a);
            return;
          }
          if (i.size > e.maxFileSize) {
            o("file-size-error", i, e.maxFileSize);
            return;
          }
          const m = h(i) ? await x(i) : i;
          r.push(m);
        }
        n.value = r, o("change", null), o("file-selected", n.value);
      } else !l.success && l.error && (l.error === "FILE_SIZE_EXCEEDED" ? o("file-size-error", new File([], "file"), e.maxFileSize) : l.error === "FILE_TYPE_NOT_ALLOWED" && o("file-type-error", new File([], "file"), ["png", "jpg", "jpeg", "pdf"]));
    }
    function E(t) {
      e.disabled || (o("click", t), q() && window.bridgeService?.requestFileUpload ? C() : g.value?.click());
    }
    async function S(t) {
      const s = t.target.files;
      if (!s) return;
      const l = Array.from(s), r = [], a = ["png", "jpg", "jpeg", "pdf"];
      for (const i of l) {
        const p = i.name.split(".").pop()?.toLowerCase() || "";
        if (!a.includes(p)) {
          o("file-type-error", i, a);
          continue;
        }
        if (i.size > e.maxFileSize) {
          o("file-size-error", i, e.maxFileSize);
          continue;
        }
        const m = h(i) ? await x(i) : i;
        r.push(m);
      }
      n.value = r, o("change", s), o("file-selected", n.value);
    }
    function j(t) {
      const s = n.value.findIndex((l) => l.name === t.name && l.size === t.size);
      s > -1 && (n.value.splice(s, 1), o("remove", t), o("file-selected", []));
    }
    return (t, s) => (c(), u("div", null, [
      z.value ? (c(), u("div", P, [
        (c(!0), u(D, null, V(n.value, (l, r) => (c(), u("div", {
          key: `${l.name}-${r}`,
          class: "flex w-full items-center justify-between rounded-sm border border-gray-200 bg-gray-50 px-4 py-[11px]"
        }, [
          f("span", X, y(l.name), 1),
          f("button", {
            type: "button",
            onClick: (a) => j(l),
            class: "ml-2 flex-shrink-0 text-gray-400 transition-colors duration-150 hover:text-red-500",
            title: "파일 제거"
          }, [
            $(F, {
              name: "close",
              size: "sm"
            })
          ], 8, Y)
        ]))), 128))
      ])) : (c(), u("button", {
        key: 0,
        type: "button",
        class: T(_.value),
        style: N(k.value),
        disabled: e.disabled,
        onClick: E
      }, [
        f("input", {
          ref_key: "inputRef",
          ref: g,
          type: "file",
          class: "sr-only",
          disabled: e.disabled,
          multiple: d.multiple,
          accept: d.accept,
          onChange: S
        }, null, 40, O),
        f("span", R, [
          f("span", M, y(d.label), 1),
          d.showIcon ? (c(), A(F, {
            key: 0,
            name: "upload",
            size: "sm",
            color: e.disabled ? "primary" : "current"
          }, null, 8, ["color"])) : U("", !0)
        ])
      ], 14, W))
    ]));
  }
});
export {
  K as default
};
